export default __webpack_public_path__ + "static/media/icon_text.0f89cc37.svg";